import SelectDropdown from '../../Search/Inputs/SelectDropdown';
import { useTranslation } from 'react-i18next';

export default function ServiceSelect(props) {
  const options = props.options.map(item => {
    return {label: item.name, value: item.id};
  });

  const {t, i18n} = useTranslation();

  return(
    <SelectDropdown id="services" label={t('services')} name="services[]" options={options} checked={props.checked}/>
  );
};
